<template>
	<div class="socials" :class="theme">
		<a
			v-for="medium in socials"
			:key="medium.ID"
			:class="medium.platform"
			:href="medium.url"
			:aria-label="medium.platform"
			target="_blank"
		>
			<font-awesome-icon v-if="medium.platform == 'twitter'" icon="fa-brands fa-x-twitter" size="1x" />
			<font-awesome-icon v-else :icon="`fa-brands fa-${medium.platform}`" size="1x" />
		</a>
	</div>
</template>

<script setup>
defineProps({
	theme: { type: String, default: 'dark' },
	socials: { type: Array, default: () => [] },
});
</script>

<style lang="scss" scoped>
.socials {
	display: flex;
	flex-flow: wrap row;
	justify-content: flex-start;
	align-items: center;

	a {
		width: 44px;
		height: 44px;
		line-height: 44px;
		text-align: center;
		font-size: 18px;
		text-decoration: none;
		color: #fff;
		background: $primary-color;
		display: flex;
		flex-flow: wrap row;
		justify-content: center;
		align-items: center;
		margin: 3px 6px 3px 0;

		&:hover {
			color: #fff;
			background: $primary-color-hover;
		}
	}

	&.light a {
		color: $primary-text-color;
		border-color: #ccc;

		&:hover {
			border-color: #999;
		}
	}
}
</style>
